import { REQUEST, MESSAGE, PERSONAL, VEHICLES } from "./types/types";

import RequestService from "../../services/request.service";
import getDate from "date-fns/getDate";
import format from "date-fns/format";

export const createRequest = (formData) => (dispatch) => {
  return RequestService.createRequest(formData).then(
    (response) => {
      dispatch({
        type: REQUEST.CREATE_REQUEST_SUCCESS,
      });
      dispatch({
        type: MESSAGE.SET_MESSAGE,
        payload: response.data.message,
      });
      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: REQUEST.CREATE_REQUEST_FAIL,
      });

      dispatch({
        type: MESSAGE.SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const GetallRequest =
  (PageNumber, PageSize, filterValue = null, initialDate = null, finalDate = null) =>
  (dispatch) => {
    return RequestService.getRequest(
      PageNumber,
      PageSize,
      filterValue,
      initialDate,
      finalDate
    ).then(
      (response) => {
        if(response.data){
        response.data.result = response.data.result?.map((request) => {
          const day = getDate(new Date(request.initialDate));
          let month = format(new Date(request.initialDate), "LLLL");
          let year = format(new Date(request.initialDate), "yyyy");
          let allInitialDate = format(
            new Date(request.initialDate),
            "MM/dd/yyyy"
          );
          let allFinalDate = format(new Date(request.finalDate), "MM/dd/yyyy");
          month = month.slice(0, 3);
          return { ...request, day, month, year, allInitialDate, allFinalDate };
        })};

        dispatch({
          type: REQUEST.GET_REQUEST,
          payload: { request: response },
        });

        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: REQUEST.CREATE_REQUEST_FAIL,
        });

        dispatch({
          type: MESSAGE.SET_MESSAGE,
          payload: message,
        });

        return Promise.reject();
      }
    );
  };

  export const editVehicle = (id, data) => (dispatch) => {
    return RequestService.editVehicle(id, data).then((response) => {
      dispatch({
        type: VEHICLES.EDIT_VEHICLE,
        payload: { vehicle: response },
      });
      return Promise.resolve();
    });
  };

//Vehicles

  export const setVehicleToEdit = (editVehicle) => {
    return {
      type: VEHICLES.SET_EDIT_VEHICLE,
      payload: { editVehicle },
    };
  }

  export const deleteVehicleToEdit = () =>{
    return {
      type: VEHICLES.DELETE_EDIT_VEHICLE,
    };
  }

//Personal

  export const setPersonalToEdit = (editPersonal)=>{
    return {
      type: PERSONAL.SET_EDIT_PERSONAL,
      payload: { editPersonal },
    };
  }

  export const deletePersonalToEdit = () =>{
    return {
      type: PERSONAL.DELETE_EDIT_PERSONAL,
    };
  }


